var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdCheckups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.648 7.987h15.537c.745 0 1.374.63 1.374 1.375 0 .744-.63 1.374-1.374 1.374H9.648c-.744 0-1.374-.63-1.374-1.374 0-.745.63-1.375 1.374-1.375ZM9.648 15.05h15.537c.745 0 1.374.629 1.374 1.374 0 .744-.63 1.374-1.374 1.374H9.648c-.744 0-1.374-.63-1.374-1.374 0-.745.63-1.375 1.374-1.375ZM21.44 23.476v.01c0 .745-.63 1.374-1.375 1.374H9.648c-.744 0-1.374-.63-1.374-1.374 0-.745.63-1.374 1.374-1.374H20.1c.75 0 1.369.597 1.34 1.364Z",
    fill: "#2FAEF3",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.188.572h22.457a5.28 5.28 0 0 1 5.294 5.294v21.116a5.28 5.28 0 0 1-5.294 5.293H6.188a5.28 5.28 0 0 1-5.294-5.293V5.866A5.28 5.28 0 0 1 6.188.572Zm22.457 28.955a2.54 2.54 0 0 0 2.546-2.545V5.866a2.54 2.54 0 0 0-2.546-2.545H6.188a2.54 2.54 0 0 0-2.545 2.545v21.116a2.54 2.54 0 0 0 2.545 2.545h22.457Z",
    fill: "#2FAEF3",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdCheckups);
export default __webpack_public_path__ + "static/media/icon-ad-checkups.ffe748e9.svg";
export { ForwardRef as ReactComponent };